import { useState, useEffect, useCallback } from 'react';
import { get, getFullUrl } from '../../../components/hooks/apiFetch';
import { useMountedRef } from '../../../components/hooks/useMountedRef';
import { useNotification } from '../../../components/index';

export const useTemplates = (options = { enabled: true }) => {
    const { enabled } = options;
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { showError } = useNotification();
    const isMounted = useMountedRef();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const reload = useCallback(() => {
        setRefreshCounter(prev => prev + 1);
    }, []);

    useEffect(() => {
        if (!enabled) {
            setTemplates([]);
            setLoading(false);
            setError(null);
            return;
        }

        const load = async () => {
            setLoading(true);
            try {
                const templatesData = await get("/api/AiMetadata/Templates");
                if (isMounted.current) {
                    setTemplates(templatesData);
                    setError(null);
                }
            } catch (err) {
                if (isMounted.current) {
                    setError(err.message);
                    showError('Не удалось загрузить шаблоны');
                }
            } finally {
                if (isMounted.current) setLoading(false);
            }
        };
        load();
    }, [enabled, refreshCounter, showError, isMounted]);

    const downloadTemplate = (templateName) => {
        if (!templateName) {
            showError('Имя шаблона не указано');
            return;
        }
        
        const url = getFullUrl(`/api/AiMetadata/Template/${encodeURIComponent(templateName)}`);
        window.open(url, '_blank');
    };

    return { templates, loading, error, downloadTemplate, reload };
};